export const API_PATHS = {
  GET_PROJECTS: '/api/projects',
  GET_SUB_PROJECTS: '/api/subProjects',
  GET_RELEASE_FILTERS: '/api/releaseFilters',
  GET_RELEASES: '/api/releases',
  GET_TARGETS: '/api/targets',
  GET_TEST_FIELDS: '/api/testFields',
  GET_FUSES: '/api/fuses',
  GET_STRAPS: '/api/straps',
  GET_LIST_FILE: '/api/buildListFile',
  GET_USER_ROLES: '/api/userPermissions/userRoles/',
  PATCH_USER_ROLE: '/api/userPermissions/requestUserRole',
  GET_LIST_AGS_REQUESTS: '/api/userPermissions/listRequests',
  GET_RECENT_EPR: '/api/recentEPR',
  GET_RECENT_PPR: '/api/recentPPR',
  GET_NB_JOBS: '/api/emulationJobs/getNBJobs',
  RUN_EPR: '/api/emulationJobs/emulationRun',
  GET_VNC_DISPLAY_DETAILS: '/api/emulationJobs/emulationVNCServer',
  EXTERNAL_API: {
    LOGIN_TOKEN: 'https://login.swiss.intel.com/login',
  },
};

export const EPC_COOKIES_KEY = 'epc-token';
